import type { Theme } from '@mui/material';
import type { StyleExtend } from 'providers/theme/theme.types';

export const SimpleHeaderStyle: StyleExtend<Theme> = {
  backgroundColor: (theme) => theme.palette.customColors.gunMetal,
  boxShadow: 'none',
};

export const SimpleHeaderToolbarStyle: StyleExtend<Theme> = {
  minHeight: (theme) => theme.customStyling.appBar.secondaryHeight,
  borderBottom: (theme) => `1px solid ${theme.palette.customColors.lightGray}`,
  justifyContent: 'space-between',
};

export const SimpleHeaderLogoWrapperStyle: StyleExtend<Theme> = {
  maxHeight: '44px',
};

export const SimpleHeaderLogoStyle: StyleExtend<Theme> = {
  width: '100%',
  height: '100%',
};
